import styles from "./EditScreenSamplePhotoGrid9.module.css";
import { useState } from "react";

const EditScreenSamplePhotoGrid9 = ({ header, subtext, images, imageText }) => {
  const [thumbPic, setThumbPic] = useState(null);
  const next_pic = () => {
    setThumbPic(thumbPic >= 5 ? 0 : thumbPic + 1);
  };
  const back_pic = () => {
    setThumbPic(thumbPic <= 0 ? 5 : thumbPic - 1);
  };
  return (
    <div className={styles.main_div}>
      <div className={styles.header_section}>
        <div name={header} className={styles.sample_section1_header}>
          {header}
        </div>
        <div className={styles.sample_section1_subtitle}>{subtext}</div>
      </div>
      <div className={styles.pictures_main}>
        <div className={styles.mid_hr1}></div>

        <div className={styles.mid_hr2}></div>
        {Array.isArray(images) &&
          images.length > 0 &&
          images.map((item, index) => {
            return (
              <div
                onClick={(event) => {
                  setThumbPic(index);
                }}
                className={styles.single_image_div}
                key={index}
              >
                <img src={item} className={styles.image} alt={"sample"} />

                <div className={styles.image_text}>
                  {imageText[Math.floor(index / 2)]}
                </div>
              </div>
            );
          })}
        {thumbPic !== null && (
          <div className={styles.modal_pic}>
            <img
              src={images[thumbPic]}
              className={styles.thumb_image}
              alt="thumb"
            />
            <div className={styles.thumb_text}>{imageText[thumbPic]}</div>
            <span
              onClick={back_pic}
              className={`${styles.arrow_icon_left} material-icons`}
            >
              keyboard_arrow_left
            </span>
            <span
              onClick={next_pic}
              className={`${styles.arrow_icon_right} material-icons`}
            >
              keyboard_arrow_right
            </span>
            <div onClick={() => setThumbPic(null)} className={styles.cross_div}>
              <ion-icon className={styles.cross_icon} name="close"></ion-icon>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default EditScreenSamplePhotoGrid9;
